import styled from 'styled-components'
import { HeadLine1 } from '../../../components/typography/styled'
import { responsiveDetailNav, responsiveDetailTitle } from '../../../components/tabs/detail-layout'


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
`
export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  padding: 10px 30px;
  ${responsiveDetailTitle}

  @media screen and (max-width: 900px) {
    padding: 10px 16px;
  }
`
export const NavWrapper = styled.div`
  border-bottom: ${({theme}) => `1px solid ${theme.grey[350]}`};
  position: relative;
  display: flex;
  margin-top:40px;
  margin-bottom:20px;
  &>div{
    position: absolute;
    bottom:-1px;
    padding-left:30px;
    left:0px;
  }
  ${responsiveDetailNav}

  @media screen and (max-width: 900px) {
    margin-bottom: 12px;

    > div {
      padding-left: 0;
    }
  }
`
export const AlertsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
  padding: 10px 30px;

  @media screen and (max-width: 900px) {
    padding: 10px 16px;
  }
`
